<template>
  <div>
    <b-row v-if="!hideName">
      <b-col lg="6">
        <b-form-group label="First Name" label-class="text-truncate label-required">
          <b-input type="text" v-model="firstName" required :disabled="disabled"/>
        </b-form-group>
      </b-col>
      <b-col lg="6">
        <b-form-group label="Last Name" label-class="text-truncate label-required">
          <b-input type="text" v-model="lastName" required :disabled="disabled"/>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <b-form-group label="Credit card number" label-class="text-truncate label-required">
          <div id="card-number" class="form-control stripe-element-container">
            <!-- Stripe Card Element -->
          </div>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col lg="6">
        <b-form-group label="Expiration date" label-class="text-truncate label-required">
          <div id="card-exp" class="form-control stripe-element-container">
            <!-- Stripe Card Expiry Element -->
          </div>
        </b-form-group>
      </b-col>
      <b-col lg="6">
        <b-form-group label="CVC" label-class="text-truncate label-required">
          <div id="card-cvc" class="form-control stripe-element-container">
            <!-- Stripe CVC Element -->
          </div>
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import POCConfig from "../../../../config.js.erb";

export default {
  props: ['disabled', 'hideName'],

  data: function () {
    return {
      firstName: null,
      lastName: null,
      stripe: null,
      card: null,
      cvc: null,
      exp: null,
    }
  },

  computed: {
    ccName() {
      return `${this.firstName || ''} ${this.lastName || ''}`
    },

    localError: function () {
      if (this.hideName) {
        return;
      }

      if (this.ccName.trim() === '') {
        return 'Name is required.';
      }

      return null;
    }
  },

  mounted: function () {
    this.stripe = Stripe(POCConfig.STRIPE_PUBLISHABLE_KEY);

    const elements = this.stripe.elements();

    const style = {
      base: {
        color: window.Theme['gray-600'],
        '::placeholder': {
          color: window.Theme['gray-500'],
        },
      }
    }

    this.card = elements.create('cardNumber', {
      placeholder: '0000 1234 4567 8900',
      showIcon: true,
      style: style
    });
    this.card.mount('#card-number');

    this.cvc = elements.create('cardCvc', {
      placeholder: '123',
      style: style
    });
    this.cvc.mount('#card-cvc');

    this.exp = elements.create('cardExpiry', {
      placeholder: 'MM/YY',
      style: style
    });
    this.exp.mount('#card-exp');
  }
}
</script>